


















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import TestimonialRatings from './TestimonialRatings.vue';
import { TypeBody } from '@bambeehr/pollen';
import TestimonialReviewer from './TestimonialReviewer.vue';
import { IBusinessInformation } from '../index';

export default defineComponent({
  name: 'TestimonialInformation',
  components: {
    TypeBody,
    TestimonialRatings,
    TestimonialReviewer,
  },
  props: {
    text: {
      type: String as PropType<string>,
      default:
        "I highly recommend Bambee to any small business owner looking for HR support. Their dedicated HR manager helped me navigate complex employment laws and policies. When an employee threatened to sue me for wrongful termination, Bambee's HR manager provided expert guidance and support that helped me resolve the issue without going to court. Thanks to Bambee, I can focus on running my business with confidence and peace of mind.",
    },
    information: {
      type: Object as PropType<IBusinessInformation>,
    },
    icon: {
      type: String as PropType<string>,
    },
  },
});
